import { useEffect, useState } from 'react';

function useFacebookLogin({ onSuccess }) {
  const deviceId = '';
  const [socialLoginRequestPayload, setSocialLoginRequestPayload] = useState();

  function getProfileInfo() {
    return new Promise((resolve, reject) => {
      window.FB.api('/me', { fields: 'name,email' }, response => {
        const profileData = {};
        console.info(`Successful login for: ${response.name}`);
        profileData.fullName = response.name;
        profileData.email = response.email;
        profileData.id = response.id;
        resolve(profileData);
      });
    });
  }

  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = () => {
        try {
          window.FB.init({
            // appId: '231928784195995',
            appId: process.env.GATSBY_FACEBOOK_CLIENT_ID || '',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v3.3',
          });
        } catch (error) {
          console.error(error);
          console.info('FACEBOOK SDK NOT DOWNLOADED');
        }
      };
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, []);

  function facebookLogin() {
    if ('FB' in window) {
      window.FB.login(result => {
        console.info(result);
        if (result.status === 'connected') {
          const authResponse = result.authResponse;
          getProfileInfo().then(profileData => {
            const fullName = profileData.fullName;
            const id = profileData.id;
            const password = profileData.id;
            const email = profileData.email;
            const image = '';
            const route = 'facebook';
            const data = {
              full_name: fullName,
              image,
              email,
              uid: id,
              password,
              brand_name: 'Your Company Name',
              route,
              referrer: 'website',
              page_source: window.location.href,
              device_id: window.deviceId || deviceId,
            };

            onSuccess(data);
          });
        }
      });
    }
  }

  return { facebookLogin };
}

export default useFacebookLogin;
